import { Grid } from "shared/components/Grid";
import { LandingIcons } from "shared/components/LandingIcons";
import { MaxWidth } from "shared/components/MaxWidth";
import { LARGE } from "shared/utils/constants";
import styles from "./IconGridSection.module.css";

export const IconGridSection = ({ title, items }) => {
  if (!title || !items?.length) return null;

  return (
    <div className={styles.container}>
      <MaxWidth size={LARGE}>
        <h2 className={styles.title}>{title}</h2>
        <Grid columns={3}>
          {(items || []).map(({ title, icon, body }) => {
            const Icon = LandingIcons[icon] || "span";

            return (
              <div key={title} className={styles.item}>
                <div className={styles.iconWrapper}>
                  <Icon />
                </div>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            );
          })}
        </Grid>
      </MaxWidth>
    </div>
  );
};
